<div [ngClass]="currentClasses" class="alert items-center flex">
  <span class="icon-alert"></span>
  <div class="alert-message">{{ errorItem.errorMessage }}</div>
</div>
